module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content question-edit-content"
  }, [_c('div', {
    staticClass: "row question-edit-body"
  }, [_vm._m(0), (_vm.error) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.error))])])]) : _vm._e(), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ngày tạo")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "created_at",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.createdAt
    }
  })])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Người tạo")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "created_by",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.createdBy
    }
  })])]), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ngày cập nhật")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "updated_at",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.updatedAt
    }
  })])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Người cập nhật")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "updated_by",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.updatedBy
    }
  })])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Danh mục câu hỏi*")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "categ-id",
      "required": "required",
      "disabled": _vm.$route.query.review
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'category')
      }
    }
  }, _vm._l((_vm.categQuestion), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id,
        "selected": o.id === _vm.categoryID
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cấp độ câu hỏi*")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "level",
      "required": "required",
      "disabled": _vm.$route.query.review
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'level')
      }
    }
  }, _vm._l((_vm.lstLevel), function(o) {
    return _c('option', {
      domProps: {
        "value": o.key,
        "selected": o.key === _vm.level
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn môn học*")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "subject-id",
      "required": "required",
      "disabled": _vm.$route.query.review
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'subject')
      }
    }
  }, _vm._l((_vm.subjects), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id,
        "selected": o.id === _vm.subjectID
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-6 lv-question col-grade-id"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.$route.query.review) ? _c('div', {
    staticClass: "opacity"
  }) : _vm._e(), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn khối lớp*")]), _c('Select2', {
    attrs: {
      "id": "grade_id",
      "options": _vm.grades,
      "settings": _vm.settingSelect2
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'grade')
      }
    },
    model: {
      value: (_vm.gradeID),
      callback: function($$v) {
        _vm.gradeID = $$v
      },
      expression: "gradeID"
    }
  })], 1)]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Thời gian thực hiện (giây)*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.time),
      expression: "time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "time",
      "type": "number",
      "required": "required",
      "min": "0",
      "step": "1",
      "disabled": _vm.$route.query.review
    },
    domProps: {
      "value": (_vm.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.time = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Số hũ mật ong học sinh cần để xem đáp án*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountHoney),
      expression: "amountHoney"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "honeyjars",
      "type": "number",
      "required": "required",
      "min": "0",
      "disabled": _vm.$route.query.review
    },
    domProps: {
      "value": (_vm.amountHoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amountHoney = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Loại câu hỏi*")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "type-id",
      "required": "required",
      "disabled": _vm.$route.query.review
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'type-question')
      }
    }
  }, _vm._l((_vm.lstTypeQuestion), function(o) {
    return _c('option', {
      domProps: {
        "value": o.key,
        "selected": o.key === _vm.typeQuestion
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-12 content-large"
  }, [_c('div', {
    staticClass: "form-group",
    style: (_vm.$route.query.review ? 'z-index: 100;' : '')
  }, [(_vm.$route.query.review) ? _c('div', {
    staticClass: "opacity"
  }) : _vm._e(), _c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "content"
    }
  }, [_vm._v("Nội dung câu hỏi lớn *")]), _c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.config,
      "disabled": _vm.$route.query.review
    },
    on: {
      "input": function($event) {
        return _vm.changeContent($event)
      }
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "col-md-12 file-attach"
  }, [_c('div', [(_vm.$route.query.review) ? _c('div', {
    staticClass: "opacity"
  }) : _vm._e(), _vm._m(1), _c('div', {
    staticClass: "box-attach"
  }, [_c('div', {
    staticClass: "box-selected-file",
    style: (_vm.$route.query.review ? 'z-index: 80;' : '')
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "files[]",
      "accept": ".mp3"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('span', [_vm._v("Chọn audio")]), _c('label', {
    staticClass: "files"
  }, [_vm._v("Cho phép file MP3")])]), _vm._l((_vm.lstFiles), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "box-item-attach"
    }, [_c('label', [_c('img', {
      staticClass: "fa-paperclip",
      attrs: {
        "src": require("../../assets/images/theory/ic_baitapcuatoi@2x.png")
      }
    }), _c('span', [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "material-icons remove",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_vm._v("delete")])]), _c('audio', {
      attrs: {
        "id": "player",
        "controls": "controls"
      }
    }, [_c('source', {
      attrs: {
        "src": item.src,
        "type": "audio/mp3"
      }
    })])]) : _vm._e()
  })], 2), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._l((_vm.questionDetails), function(qd, qd_index) {
    return _c('div', {
      staticClass: "col-md-12 col-md-question"
    }, [_c('questionDetail', {
      key: _vm.force,
      attrs: {
        "qd_index": qd_index + 1,
        "objQd": qd,
        "type_question": _vm.typeQuestion,
        "not_delete": _vm.notDelete,
        "review": _vm.review
      },
      on: {
        "onItemDelete": _vm.deleteQuestionDetail,
        "dataQuestionDetail": _vm.onDataQuestionDetail,
        "onEditTheory": _vm.editTheory
      }
    }), _c('div', {
      staticClass: "clearfix"
    })], 1)
  }), (_vm.typeQuestion === 2 && !_vm.$route.query.review) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "add-question",
    on: {
      "click": _vm.addQuestion
    }
  }, [_vm._v("+ Thêm câu hỏi mới")])]) : _vm._e(), _c('div', {
    staticClass: "col-md-12 col-checkbox"
  }, [(!_vm.$route.query.review) ? _c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "cb_question",
      "id": "cb_question"
    },
    domProps: {
      "checked": _vm.is_save_edit
    },
    on: {
      "click": _vm.clickSaveEdit
    }
  }), _c('label', {
    attrs: {
      "for": "cb_question"
    }
  }), _c('span', [_vm._v("Lưu lại và chỉnh sửa sau")])]) : _vm._e(), _c('div', {
    staticClass: "button-handle"
  }, [(!_vm.$route.query.review) ? _c('button', {
    staticClass: "btn btn-active",
    on: {
      "click": function($event) {
        return _vm.validateSave(2)
      }
    }
  }, [_vm._v("Lưu và tạo câu hỏi mới")]) : _vm._e(), (!_vm.$route.query.review) ? _c('button', {
    staticClass: "btn btn-active",
    on: {
      "click": function($event) {
        return _vm.validateSave(1)
      }
    }
  }, [_vm._v("Lưu lại và hoàn tất")]) : _vm._e(), (!_vm.$route.query.review) ? _c('button', {
    staticClass: "btn btn-rest",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.validateSave(3)
      }
    }
  }, [_vm._v("Huỷ yêu cầu")]) : _vm._e()])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-md-header"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Chỉnh sửa câu hỏi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "attach"
  }, [_c('strong', [_vm._v("File đính kèm")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22b002b5","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question/edit.vue
// module id = 1507
// module chunks = 0